import multicallAbi from './abi/multicall.json';
import { Call } from './call';
import EthcallContract from './contract';

function getEthBalance(address: string, multicallAddress: string): Call {
  const multicall = new EthcallContract(multicallAddress, multicallAbi);
  return multicall.getEthBalance(address) as Call;
}

export default getEthBalance;
